module.exports = __webpack_public_path__ + "static/media/g.2161ce7c.m4a";